var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{attrs:{"border":"left","colored-border":"","type":"info","elevation":"1"}},[_vm._v(" 开发中，目前只支持结构查看 ")]),_c('ObjView',{attrs:{"Tree":_vm.LMTTree}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }